module.exports = __webpack_public_path__ + "img/ln4.3457edda.png";